import { DraggableColLabels } from './StatsBaseTableStore.types'
import { ProductProjectEventStatDTO, ProductProjectSalesDTO, ProjectDTO, ProjectProductStatDTO } from '../../models'

export const getCorrespondingEntityIdKey = (label: DraggableColLabels): string => {
  switch (label) {
    case DraggableColLabels.PRODUCTS: return 'productId'
    case DraggableColLabels.PROJECT: return 'projectId'
    case DraggableColLabels.STORE: return 'brandId'
    default: return ''
  }
}

export const getProductProjectStatMapKey = (
  data: ProductProjectEventStatDTO | ProductProjectSalesDTO | ProjectProductStatDTO
): string => {
  return `${data.productId}-${data.projectId}-${data.brandId}`
}

export const hasMatchingChild = (project: ProjectDTO, ids: Set<number>): boolean => {
  if (ids.has(project.id)) {
    return true
  } else if (project.children) {
    return project.children.some(project => hasMatchingChild(project, ids))
  } else {
    return false
  }
}
